/**
 * Created by claude on 22.07.26.
 * Leaf scene component extracted from TriPeaksScene
 */

class TriPeaksSceneComponent extends ScriptComponent {
    onAttach() {
        this.base = ComponentMap.get(this.node, TileGameSceneComponent);
        this.base.leaf = this;
    }

    buildHandBlockView() {
        const tripeaks = Game.currentGame;

        this.handView = new HandView(tripeaks.hand);

        if (cleverapps.boosters.getBoosterById(cleverapps.Boosters.TYPE_UNDO).isAvailable()) {
            this.undoBlock = new UndoBlock(Game.currentGame.log);
        }

        this.openCardsControl = new OpenCardsView(Game.currentGame.open);
        this.handBlockView = new HandBlockView(this.handView, this.undoBlock, this.openCardsControl);
        return this.handBlockView;
    }

    hasWildCardBooster() {
        return Game.currentGame.wildcardBooster.isAvailable();
    }

    buildWildCardButton() {
        this.wildCardButtonNode = new WildCardButton(Game.currentGame.wildcardBooster, this.node);
        return this.wildCardButtonNode;
    }

    hasDice() {
        return Boolean(Game.currentGame.dice);
    }

    buildDiceView() {
        return new DiceView(Game.currentGame.dice);
    }

    hasArrows() {
        return cleverapps.resolution.mode !== cleverapps.WideMode.VERTICAL;
    }

    buildArrows() {
        return new MultiScreenArrows(Game.currentGame.table);
    }

    hasCombo() {
        return Boolean(Game.currentGame.combo);
    }

    buildComboView() {
        this.comboView = new ComboBarView(Game.currentGame.combo);
        return this.comboView;
    }

    hasRewardGold() {
        return Boolean(Game.currentGame.levelWithCoins);
    }

    buildRewardGoldView() {
        this.rewardGoldView = new RewardGoldView();
        return this.rewardGoldView;
    }

    getWildCardControlId() {
        return Game.currentGame.wildcardBooster.getControlId();
    }

    onReady() {
        this.handBlockView.setLocalZOrder(this.base.cardTableView.getLocalZOrder() - 1);
        this.handBlockView.onResize();

        if (this.wildCardButtonNode) {
            this.wildCardButton = this.wildCardButtonNode.getParent();
        }

        let rewardGoldControl, comboBarControl;

        if (this.comboView) {
            comboBarControl = this.comboBarControl = this.comboView.getParent();
        }

        if (this.rewardGoldView) {
            rewardGoldControl = this.rewardGoldView.getParent();
        }

        if (!this.horizontalBlocker) {
            if (comboBarControl || rewardGoldControl) {
                this.horizontalBlocker = new HorizontalBlockerNode(comboBarControl || rewardGoldControl);
                this.node.addChild(this.horizontalBlocker);
            }
        }

        Game.currentGame.on("outOfMoves", this.outOfMoves.bind(this), this.node);

        this.base.onResize();
    }

    getOverlappingNodes() {
        return [this.horizontalBlocker, this.openCardsControl, this.handView, this.handBlockView];
    }

    createBonusChest() {
        const bonusChest = this.bonusChest = new ChestVictoryAnimation();
        bonusChest.setAlignment(cleverapps.styles.ChestVictoryAnimation.chestPosition);

        this.node.addChild(bonusChest);

        return bonusChest;
    }

    outOfMoves(prolongationOffer) {
        cleverapps.focusManager.display({
            focus: "AddCardsWindow",
            action: function (f) {
                new ProlongationWindow(Game.currentGame.prolongation, {
                    offer: prolongationOffer,
                    onGiveUp: function () {
                        Game.currentGame.lose();
                    }
                });
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
}

Prefab.registerComponent("TriPeaksSceneComponent", TriPeaksSceneComponent);

GameScene = bundles.main.jsons.tripeaksscene_prefab_json;
